import { FC, useState } from 'react';
import * as yup from 'yup';
import { PickupService } from '../../../services/pickup/pickupService';
import { useFormik } from 'formik';
import ModalForm from '../../../components/forms/ModalForm';
import { Textarea, Button } from 'rizzui';
import useHandleErrors from '../../../hooks/useHandleErrors';
import { toast } from 'sonner';


interface ValidatePickupModalProps{
    isOpen: boolean;
    onClose: () => void;
    ids: string[];
}


const validationSchema = yup.object({
    comment: yup.string().required("Comentario requerido"),
});

const ValidatePickupModal: FC<ValidatePickupModalProps> = ({ isOpen, onClose, ids }) => {
    const [loading, setLoading] = useState(false);

    // SERVICES
    
    const pickupService = new PickupService();
    const { handleErrors } = useHandleErrors();
    
    // FORM

    const formik = useFormik({
        initialValues: {
            pickups: ids,
            comment: "",
            status: ""
        },
        validationSchema,
        onSubmit: async (values) => {
            handleSubmit(values);
        }
    })

    // FUNCTIONS

    // -------------------------------------------------------------------------------------------------
    /**
     * @ES Manejo del formulario de validación.
     * @EN Handle the validation form.
     * @param values - Valores del formulario. / Form values.
     */
    // -------------------------------------------------------------------------------------------------
    const handleSubmit = async (values: typeof formik.initialValues) => {
        setLoading(true);
        try {
            const response = await (await pickupService.adminValidation(values)).getResponseData();
            if (response.success) {
                toast.success("Recogida/s administradas con éxito");
                setLoading(false);
                onClose();
            }else{
                handleErrors(response);
            }
        } catch (error) {
            handleErrors(error);
            setLoading(false);
        }
    }
    // -------------------------------------------------------------------------------------------------

    const handleClose = () => {
		formik.resetForm()
		onClose();
	};
    // RENDER

    return (
        <ModalForm
            isOpen={isOpen}
            onClose={handleClose}
            title='Validar Recogida'
        >
            <form onSubmit={formik.handleSubmit} className='space-y-6'>
                <div>
                
                    <div className='md:col-span-12'>
                        <Textarea
                            id='comment'
                            name='comment'
                            label="Comentario"
                            placeholder="Comentario"
                            required
                            rows={4}
                            value={formik.values.comment}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.comment}
                        />
                        </div>

                </div>
				<div className="flex justify-end gap-3 py-4 border-t">
                    <Button
                        type="button"
                        className="bg-green-600 hover:bg-green-700 text-white"
                        disabled={loading || !formik.values.comment.trim()}
                        onClick={() => {
                            formik.setFieldValue('status', 'validated_by_admin');
                            formik.handleSubmit();
                        }}
                    >
                        Confirmar
                    </Button>
                    <Button
                        type="button"
                        className="bg-red-600 hover:bg-red-700 text-white"
                        disabled={loading || !formik.values.comment.trim()}
                        onClick={() => {
                            formik.setFieldValue('status', 'rejected_by_admin');
                            formik.handleSubmit();
                        }}
                    >
                        Rechazar
                    </Button>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                </div>
            </form>

        </ModalForm>

        )

}

export default ValidatePickupModal;
